import { ChannelBuilderComponent } from './components/channel_component/channel_builder_component_controller';

angular.module('ui-ng-sgd-components', []).component('channelBuilderComponent', new ChannelBuilderComponent());

import './core';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sgd-components/src/main.ts